module.exports = __webpack_public_path__ + "img/screen-manual-19.d9f74dfc.png";